<template>
    <transition name="loader-fade">
        <div class="g-loader" :style="gStyles">
            <v-progress-circular indeterminate :color="progressColor" size="60" width="5"/>
        </div>
    </transition>
</template>

<script>
    export default {
        name    : "Loader",
        props   : {
            transparent: {
                default: false,
                type   : Boolean,
            }
        },
        data() {
            return {
                progressColor: '#2196F3'
            }
        },
        computed: {
            gStyles() {
                return {
                    'background-color': this.transparent === true ? 'rgba(255,255,255, 0.7)' : 'rgba(255,255,255, 1)'
                }
            },
        }
    }
</script>

<style lang="scss">

    .g-loader {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        opacity: 1;
    }

    .loader-fade-enter-active, .loader-fade-leave-active {
        transition: opacity .2s;
    }

    .loader-fade-enter, .loader-fade-leave-to {
        opacity: 0;
    }

    .loader-fade-leave-active {
        transition-delay: 0.1s;
    }
</style>
